import { useState } from 'react';
import { Box } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import { OBCard } from 'features/Bento/components';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import Bolt from './assets/Bolt@2x.png';
import Easy from './assets/Easy@2x.png';
import IDCard from './assets/IDCard@2x.png';
import Notepad from './assets/Notepad@2x.png';
import locales from './locales';

const getItems = () => [
  <Box key="intro">
    <OBCard.Illustration src={Bolt} />

    <OBCard.Body textAlign="center">
      <Heading marginBottom="space-16" size="lg">
        {locales.intro.title}
      </Heading>

      <Text>{locales.intro.description}</Text>
    </OBCard.Body>
  </Box>,

  <Box key="companyApplication">
    <OBCard.Illustration src={Notepad} />

    <OBCard.Body textAlign="center">
      <Heading marginBottom="space-16" size="lg">
        {locales.companyApplication.title}
      </Heading>

      <Text>{locales.companyApplication.description}</Text>
    </OBCard.Body>
  </Box>,

  <Box key="personalInfo">
    <OBCard.Illustration src={IDCard} />

    <OBCard.Body textAlign="center">
      <Heading marginBottom="space-16" size="lg">
        {locales.personalInfo.title}
      </Heading>

      <Text>{locales.personalInfo.description}</Text>
    </OBCard.Body>
  </Box>,

  <Box key="outro">
    <OBCard.Illustration src={Easy} />

    <OBCard.Body textAlign="center">
      <Heading marginBottom="space-16" size="lg">
        {locales.outro.title}
      </Heading>

      <Text>{locales.outro.description}</Text>
    </OBCard.Body>
  </Box>,
];

interface WelcomeMandateeProps {
  onNext: () => void;
}

const WelcomeMandatee = asBentoPage<WelcomeMandateeProps>(
  ({ Layout, onNext }) => {
    const [carouselIndex, setCarouselIndex] = useState(0);
    const items = getItems();
    const isLastStep = carouselIndex >= items.length - 1;

    const handleClick = () => {
      if (isLastStep) {
        onNext();
      } else {
        setCarouselIndex(carouselIndex + 1);
      }
    };

    return (
      <Layout data-testid="welcome-mandatee" nav={<OBNavigation />}>
        <OBCard>
          <OBCard.Carousel
            onChange={(index) => setCarouselIndex(index)}
            value={carouselIndex}
          >
            {items}
          </OBCard.Carousel>

          <OBCard.Footer>
            <Button isExpanded onClick={handleClick}>
              {isLastStep ? locales.start : locales.next}
            </Button>
          </OBCard.Footer>
        </OBCard>
      </Layout>
    );
  },
);

export default WelcomeMandatee;
